import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/firebase";
import { signInWithEmailAndPassword, signInWithCustomToken } from "firebase/auth";
import { FaFacebook, FaArrowLeft } from "react-icons/fa";
import "../styles/Auth.css";

const authErrorMessages = {
  "auth/invalid-credential": "Incorrect email or password.",
  "auth/user-not-found": "No account found with this email.",
  "auth/wrong-password": "Incorrect email or password.",
  "auth/invalid-email": "That email address doesn't look right.",
  "auth/too-many-requests": "Too many attempts — please wait a moment and try again.",
  "auth/network-request-failed": "Network error — check your connection and try again.",
};
const friendlyAuthError = (err) => authErrorMessages[err.code] || err.message;

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFacebookLogin = async () => {
    setLoading(true);
    setError("");
    try {
      const fbAppId = process.env.REACT_APP_FB_ID;
      const redirectUri = encodeURIComponent("https://adsoar.cc/api/fb/login");
      const configId = "908867225432198";
      const loginUrl = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${fbAppId}&redirect_uri=${redirectUri}&config_id=${configId}&response_type=code`;
      const popup = window.open(loginUrl, "fb_login", "width=600,height=700,scrollbars=yes");

      const handleMessage = async (event) => {
        if (event.origin !== "https://adsoar.cc") return;
        if (event.data?.type === "FB_LOGIN_SUCCESS" && event.data.token) {
          window.removeEventListener("message", handleMessage);
          try {
            const result = await signInWithCustomToken(auth, event.data.token);
            onLogin(result.user);
          } catch (tokenErr) {
            setError("Failed to complete sign-in. Please try again.");
            setLoading(false);
          }
        }
      };

      window.addEventListener("message", handleMessage);

      const checkClosed = setInterval(() => {
        if (popup && popup.closed) {
          clearInterval(checkClosed);
          window.removeEventListener("message", handleMessage);
          setLoading(false);
        }
      }, 1000);
    } catch (err) {
      setError(err.message || "Facebook login failed. Please try again.");
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      onLogin(userCredential.user);
    } catch (err) {
      setError(friendlyAuthError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">

      {/* Left branding */}
      <div className="auth-left">
        <div className="auth-left-logo" onClick={() => navigate("/")}>Ad<span>soar</span></div>
        <div className="auth-left-body">
          <h1 className="auth-left-title">
            Welcome<br />
            <span className="auth-left-gradient">back.</span>
          </h1>
          <p className="auth-left-sub">
            Your campaigns, audiences, and performance data are waiting for you.
          </p>
          <div className="auth-left-features">
            {["Campaign creation wizard", "Audience management", "Performance dashboard"].map((f, i) => (
              <div className="auth-left-feature" key={i}>
                <span className="auth-left-check">✓</span>
                {f}
              </div>
            ))}
          </div>
        </div>
        <div className="auth-left-footer">© {new Date().getFullYear()} Adsoar</div>
      </div>

      {/* Right form */}
      <div className="auth-right">
        <div className="auth-form-wrap">
          <button className="auth-back" onClick={() => navigate("/")}>
            <FaArrowLeft style={{ fontSize: "0.75rem" }} /> Back to home
          </button>

          <h2 className="auth-title">Sign in</h2>

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="auth-label">Email</label>
              <input className="auth-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required />
            </div>
            <div className="auth-field">
              <label className="auth-label">Password</label>
              <input className="auth-input" type="password" value={password}
                onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            {error && <div className="auth-error">{error}</div>}
            <button className="auth-submit" type="submit" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="auth-divider">
            <span className="auth-divider-line" />
            <span className="auth-divider-text">or</span>
            <span className="auth-divider-line" />
          </div>

          <button className="auth-fb-btn" onClick={handleFacebookLogin} disabled={loading}>
            <FaFacebook style={{ fontSize: "1.1rem" }} />
            {loading ? "Connecting..." : "Continue with Facebook"}
          </button>

          <p className="auth-toggle">
            New to Adsoar?{" "}
            <button className="auth-toggle-link" onClick={() => navigate("/signup")}>Create an account</button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
